export const setAnalyticsAttribute = baseElement => {
  const baseEl = document.querySelectorAll(baseElement);

  if (baseEl) {
    baseEl.forEach(el => {
      el.querySelectorAll("button, a").forEach(interactiveEl => {
        let textValue = "";

        if (interactiveEl.innerText || interactiveEl.hasAttribute("aria-label")) {
          if (interactiveEl.innerText) {
            textValue = interactiveEl.innerText.split(".")[0];
          } else {
            textValue = interactiveEl.getAttribute("aria-label");
          }
          interactiveEl.setAttribute("data-linkval", textValue);
        }
      });
    });
  }
};
export const sendCustomEvent = evt => {
  if (document.createEvent && document.body.dispatchEvent) {
    const event = document.createEvent("Event");
    event.initEvent(evt, true, true); //can bubble, and is cancellable
    document.body.dispatchEvent(event);
  } else if (window.CustomEvent && document.body.dispatchEvent) {
    const event = new CustomEvent(evt, {
      bubbles: true,
      cancelable: true
    });
    document.body.dispatchEvent(event);
  }
};
